import { render, staticRenderFns } from "./EditCaregiverDialog.vue?vue&type=template&id=522f2bb4&"
import script from "./EditCaregiverDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCaregiverDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports